import { render, staticRenderFns } from "./CardCarousel.vue?vue&type=template&id=1dadc61c&scoped=true&"
import script from "./CardCarousel.vue?vue&type=script&lang=ts&"
export * from "./CardCarousel.vue?vue&type=script&lang=ts&"
import style0 from "./CardCarousel.vue?vue&type=style&index=0&id=1dadc61c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dadc61c",
  null
  
)

export default component.exports